/**
 * Helper function to convert 24-hour time to 12-hour format with AM/PM
 * @param {string} time24 - Time in 24-hour format (e.g., "14:30")
 * @returns {string} Time in 12-hour format (e.g., "2:30 PM")
 */
function convertTo12Hour(time24) {
  const [hours, minutes] = time24.split(':');
  let hour = parseInt(hours, 10);
  const minute = minutes;
  const period = hour >= 12 ? 'PM' : 'AM';
  
  if (hour === 0) {
    hour = 12;
  } else if (hour > 12) {
    hour = hour - 12;
  }
  
  return `${hour}:${minute} ${period}`;
}

/**
 * Helper function to convert 12-hour time to 24-hour format
 * @param {string} time12 - Time in 12-hour format (e.g., "2:00 PM")
 * @returns {string} Time in 24-hour format (e.g., "14:00")
 */
function convertTo24Hour(time12) {
  const [time, period] = time12.split(' ');
  let [hours, minutes] = time.split(':');
  hours = parseInt(hours, 10);
  
  if (period === 'PM' && hours !== 12) {
    hours += 12;
  } else if (period === 'AM' && hours === 12) {
    hours = 0;
  }
  
  return `${hours.toString().padStart(2, '0')}:${minutes}`;
}

/**
 * Helper function to calculate end time based on start time and duration
 * @param {string} startTime - Start time in 24-hour format (e.g., "14:00")
 * @param {number} durationMinutes - Duration in minutes (default 15)
 * @returns {string} End time in 24-hour format (e.g., "14:15")
 */
function calculateEndTime(startTime, durationMinutes = 15) {
  const [hours, minutes] = startTime.split(':');
  const startMinutes = parseInt(hours, 10) * 60 + parseInt(minutes, 10);
  const endMinutes = startMinutes + durationMinutes;
  const endHours = Math.floor(endMinutes / 60);
  const endMins = endMinutes % 60;
  
  return `${endHours.toString().padStart(2, '0')}:${endMins.toString().padStart(2, '0')}`;
}

module.exports = {
  convertTo12Hour,
  convertTo24Hour,
  calculateEndTime,
};

